<template>
  <div>
    <NavbarItem />
    <div class="container">
      <div class="row" style="margin-top:150px;">
        <h2>Daftar <strong>Makanan</strong></h2>
      </div>

      <div class="row mt-3">
        <div class="col">
          <div class="input-group mb-3">
            
            <input 
              v-model="search"
              @keyup="searchFood"
              type="text"
              class="form-control"
              placeholder="Cari Makanan Kesukaan Anda"
              aria-label="Username"
              aria-describedby="basic-addon1"
            />
          <div class="input-group-prepend">
              <span class="input-group-text" id="basic-addon1"><b-icon-search></b-icon-search></span>
          </div>
          </div>
         
        </div>
      </div>
      <div class="row mb-3">
        <div
          class="col-6 mt-3"
          v-for="product in products"
          :key="product.id"
        >
          <CardProduct :product="product" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import NavbarItem from "@/components/Navbar.vue";
import CardProduct from "@/components/CardProduct.vue";
import { api, apiRoutes } from "@/utils/api";

export default {
  name: "FoodsView",
  components: {
    NavbarItem,
    CardProduct,
  },

  data() {
    return {
      products: [],
      search: "",
    };
  },

  methods: {
    setProducts(data) {
      this.products = data;
    },

    async searchFood() {
      try {
        const res = await api(apiRoutes.productsCari(this.search), {
          method: "GET",
        });
        this.setProducts(res.data);
      } catch (error) {
        console.log("Gagal", error);
      }
    },
  },

  async mounted() {
    try {
      const res = await api(apiRoutes.products, { method: "GET" });
      this.setProducts(res.data);
    } catch (error) {
      console.log("Gagal", error);
    }
  },
};
</script>